import React from "react"
import {StyledFacetsButton} from "./components"

interface FacetsButtonProps {
    onClick: (event: React.MouseEvent<HTMLButtonElement>) => void
    text: string
    large?: boolean
    "data-testid"?: string
}

export const FacetsButton = ({large, onClick, text, ...rest}: FacetsButtonProps) => (
    <StyledFacetsButton
        large={large}
        type="button"
        onClick={onClick}
        disableRipple
        disableElevation
        disableFocusRipple={false}
        data-testid={rest["data-testid"]}
    >
        {text}
    </StyledFacetsButton>
)

export default FacetsButton
